<h1 class="u-sr-only">{{ 'Sidebar.Menu.Toolkit' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__header">
		<h1 class="c-section__title c-section__title--sm">{{ 'Sidebar.Menu.Toolkit' | translate }}</h1>
		<p class="c-text c-text--gray toolkit__subtitle">{{ 'Toolkit.Subtitle' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card toolkit">
					<loader-overlay *ngIf="vm.loading"></loader-overlay>

					<div class="c-content">
						<div class="c-tabs u-no-mb">
							<a
								href="javascript:void(0)"
								(click)="vm.setActiveTab('overview')"
								style="cursor:pointer;"
								class="c-tabs__link c-tabs__link--sm"
								[ngClass]="{'c-tabs__link--active': vm.activeTab === 'overview'}">
								{{ 'Toolkit.Tabs.Overview' | translate }}
							</a>
							<a
								href="javascript:void(0)"
								(click)="vm.setActiveTab('clients')"
								style="cursor:pointer;"
								class="c-tabs__link c-tabs__link--sm"
								[ngClass]="{'c-tabs__link--active': vm.activeTab === 'clients'}">
								{{ 'Toolkit.Tabs.Clients' | translate }}
							</a>
							<a
								href="javascript:void(0)"
								(click)="vm.setActiveTab('library')"
								style="cursor:pointer;"
								class="c-tabs__link c-tabs__link--sm"
								[ngClass]="{'c-tabs__link--active': vm.activeTab === 'library'}">
								{{ 'Toolkit.Tabs.Library' | translate }}
							</a>
							<a
								href="javascript:void(0)"
								(click)="vm.setActiveTab('surveys')"
								style="cursor:pointer;"
								class="c-tabs__link c-tabs__link--sm"
								[ngClass]="{'c-tabs__link--active': vm.activeTab === 'surveys'}">
								{{ 'Toolkit.Tabs.Surveys' | translate }}
							</a>
							<a
								href="javascript:void(0)"
								(click)="vm.setActiveTab('history')"
								style="cursor:pointer;"
								class="c-tabs__link c-tabs__link--sm"
								[ngClass]="{'c-tabs__link--active': vm.activeTab === 'history'}">
								{{ 'Toolkit.Tabs.History' | translate }}
							</a>
						</div>
					</div>

					<div class="c-content">
						<ng-container [ngSwitch]="vm.activeTab">
							<toolkit-overview *ngSwitchCase="'overview'" [vm]="vm"></toolkit-overview>
							<toolkit-clients *ngSwitchCase="'clients'" [vm]="vm"></toolkit-clients>
							<toolkit-library *ngSwitchCase="'library'" [vm]="vm"></toolkit-library>
							<toolkit-surveys *ngSwitchCase="'surveys'" [vm]="vm"></toolkit-surveys>
							<toolkit-history *ngSwitchCase="'history'" [vm]="vm"></toolkit-history>
							<div *ngSwitchDefault class="toolkit__emptyPane">
								<div class="toolkit__emptyTitle">{{ 'Toolkit.Placeholder.Title' | translate }}</div>
								<div class="toolkit__emptyText">{{ 'Toolkit.Placeholder.Text' | translate }}</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
